import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import { getApi } from "@services/axios";
import Header from "@components/header";
import { routes } from "@utils/constant";
import EditBlock from "./edit-block";
import Tabbing from "./tabbing";
import { JobDetailStyle } from "./style";

export default function DetailPage() {
  const classes = JobDetailStyle();
  const { id } = useParams();
  const history = useHistory();
  const [jobsData, setJobsData] = useState([]);

  let getJobs = () => {
    setJobsData(null);
    getApi(`jobs/${id}`, null, false)
      .then((response) => {
        setJobsData(response.data.data);
        // setLoadingJobs(false);
      })
      .catch((error) => {
        setJobsData(error);
        // setLoadingJobs(false);
        if (error?.response?.status === 404) {
          history.push(routes.pageNotFound);
        }
      });
  };
  useEffect(() => {
    getJobs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Header />
      <div className={classes.JobDetailWrapper}>
        <div className="wrapper job-detail-page">
          <div className="inner-page">
            <div className={classes.backLinkWrapper}>
              <Link to={routes.jobListing} className={classes.backToPage}>
                <ArrowBackIosIcon /> Back to jobs
              </Link>
            </div>
            <div className="detail-col-layout">
              <div className="left-block">
                <EditBlock
                  jobsData={jobsData}
                  loadingJobs={jobsData === null && true}
                />
              </div>
              <div className="right-block">
                <Tabbing jobsData={jobsData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
